import React, {Component} from 'react';
import {get as _get, uniqueId} from 'lodash';
import moment from "moment";
import assets from "../../../util/assets";
import {Col, Row} from "reactstrap"
import "./index.css";
import "../common.css";
import {getData, LOGIN} from "../../../util/storage";
import {isEmpty, LogException, vuePayLog} from "../../../util/utility";

const isPublisher = (item) => {
    return item.hasOwnProperty("type") && item.type.indexOf("Publisher") >= 0;
};

const getUserData = (item, key) => {
    return item.hasOwnProperty("userData") && item.userData.hasOwnProperty(key) && item.userData[key];
};

const getUsername = (item) => {
    if (isPublisher(item)) {
        return getUserData(item, "username")
    } else if (item.hasOwnProperty("type") && item.type.indexOf("VuePay") >= 0) {
        return "VuePay";
    } else {
        return getUserData(item, "username")
    }
};

const handleClick = (actionsAllowed,item, usernameClicked) => {
    if(actionsAllowed){
        if (isPublisher(item)) {

        } else if (item.hasOwnProperty("type") && item.type.indexOf("VuePay") >= 0) {

        } else {
            usernameClicked(item);
        }
    }
}

const scrollChatToTop = () => {
    const elmnt = document.getElementById("divElem");
    if (elmnt) {
        elmnt.scrollTop = elmnt.scrollHeight + 36;
    }
};

const ChatList = ({actionsAllowed,items, usernameClicked}) => {
    const listItems = items.map((item, index) => {
        return (
            <li key={`chat-list-item-${index}`}>
                <div className="chat-list-item-container">
                    <Row className="chat-list-item-right-container no-padding no-margin">
                        {
                            !isPublisher(item) && <Col sm="2">&nbsp;</Col>
                        }
                        <Col sm="2" className="chat-list-item-img-container">
                            <img className="chat-list-item-user-profile"
                                 src={getUserData(item, "profile_pic")}
                                 alt="user profile image" onClick={() => {
                                vuePayLog("ChatComponent","","Profile image clicked");
                                handleClick(actionsAllowed,item, usernameClicked)
                            }}/>
                        </Col>
                        <Col sm="8" className="chat-list-item-message-container flex-vertical">
                            <div className="username" onClick={() => {
                                vuePayLog("ChatComponent","","Username clicked");
                                handleClick(actionsAllowed,item, usernameClicked)
                            }}>
                                {getUsername(item).toUpperCase()}
                            </div>
                            <div className="message">{item.text}</div>
                        </Col>
                        {
                            isPublisher(item) && <Col sm="2">&nbsp;</Col>
                        }
                    </Row>
                    <Row className="chat-list-item-right-time no-padding no-margin">
                        <Col sm={isPublisher(item) ? 10 : 12} className="no-padding no-margin" style={{marginTop: 2}}>
                            {moment(item.createdAt).format("hh:mm a")}
                        </Col>
                        {
                            isPublisher(item) && <Col sm="2">&nbsp;</Col>
                        }
                    </Row>
                </div>
            </li>
        );
    });

    //scrollChatToTop();

    return <ul className="chat-list-item-ul no-margin no-padding" id="divElem">{listItems}</ul>;
};

export default class ChatComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loggedIn: false,
            message: ''
        };
        //all the functions used in this component should be listed here for better documentation
        this.sendChat = this.sendChat.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
    }

    componentDidMount() {
        getData(LOGIN)
            .then((data) => {
                this.setState({
                    loggedIn: (!isEmpty(data)) && data.api_token
                })
            })
    }

    showLogin = () => {
        this.props.history.push(
            {
                pathname: '/login',
                state: {
                    basePath: this.props.history.location.pathname,
                    search: _get(this.props, 'history.location.search', '')
                }
            }
        );
    };

    sendIfLoggedIn = () => {
        if (this.props.userType === "Viewer") {
            if (this.state.loggedIn) {
                this.sendChat()
            } else {
                this.showLogin()
            }
        } else {
            this.sendChat();
        }
    };

    sendChat = () => {
        const input = this.state.message.trim();
        if (input.length >= 1) {
            this._resetInput();
            this.props.session.signal({
                    data: input,
                    type: this.props.userType
                }, (error) => {
                    if (error) {
                        LogException("StartBroadcast", "sendChat", error);
                    } else {
                        scrollChatToTop()
                    }
                }
            );
        }
    }

    _onChange = (e) => {
        this.setState({
            message: e.target.value
        })
    };

    _resetInput = () => {
        this.setState({
            message: ''
        })
    };

    _handleKeyPress = (e) => {
        if (this.props.userType === "Viewer") {
            if (this.state.loggedIn) {
                if (e.key === 'Enter') {
                    if (e.target.value.trim().length >= 1) {
                        this.sendChat();
                    }
                }
            } else {
                e.preventDefault();
                this.showLogin();
            }
        } else {
            if (e.key === 'Enter') {
                if (e.target.value.trim().length >= 1) {
                    this.sendChat();
                }
            }

        }
    }

    _handleUserNameClickEvent = (connection) => {
        //user_api_id username
        if (connection.hasOwnProperty("userData") &&
            connection.userData.hasOwnProperty("user_api_id") &&
            connection.userData.hasOwnProperty("username") &&
            connection.userData.username !== connection.userData.user_api_id &&
            connection.userData.username !== "guest") {

            this.props.setUserData(connection);
            this.props.toggleInviteForSessionModal()
        }

    }

    render() {
        const {signalArray} = this.props;

        return (
            <div className="chat-component-container">
                <Row className="chat-component-header-container">
                    <Col className="chat-component-header">Comments</Col>
                    <Col className="chat-component-header-close">
                        <img src={assets.broadcast.cross}
                             onClick={() => {
                                 vuePayLog("ChatComponent","","Cross icon clicked");
                                 this.props.setRightLayout("");
                             }}
                             alt="cross icon"
                             width={13}/>
                    </Col>
                </Row>
                <div className="chat-component-header-divider "/>
                <ChatList actionsAllowed={this.props.actionsAllowed} items={signalArray} usernameClicked={this._handleUserNameClickEvent}/>
                {/*<div className="chat-component-header-divider "/>*/}
                <Row className="chat-list-text-input-container">
                    <Col sm="10">
                        <input type="text"
                               value={this.state.message}
                               className="form-control"
                               id="chat-input-text"
                               placeholder="Chat here..."
                               onKeyPress={this._handleKeyPress}
                               onChange={this._onChange}/>
                    </Col>
                    <Col sm="2" className="flex-vertical-center">
                        {
                            this.state.message.length > 0
                                ?
                                <img src={assets.broadcast.send_enable} width={20} onClick={this.sendIfLoggedIn}/>
                                :
                                <img src={assets.broadcast.send_disable} width={20}/>
                        }
                    </Col>
                </Row>
            </div>
        )
    }
}


